import { apiFetch } from './client'
import type { ApiMe } from './types'

/** POST /api/auth/login — sets the HttpOnly portal session cookie (PRD P0.2). */
export async function login(email: string, password: string): Promise<void> {
  await apiFetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  })
}

/** POST /api/auth/logout — clears the session cookie. Failures are ignored. */
export async function logout(): Promise<void> {
  try {
    await apiFetch('/api/auth/logout', { method: 'POST' })
  } catch {
    // best effort — the login screen is shown regardless
  }
}

/** GET /api/me — throws ApiError(kind 'auth') when there is no valid session. */
export async function fetchMe(): Promise<ApiMe> {
  const res = await apiFetch('/api/me')
  return res.json() as Promise<ApiMe>
}
